import { useCallback } from 'react';
import { useRegisterResponseAction } from '../../context/useRegisterResponseAction';
import { ResponseActionScope } from '../../../types/context';

export const useReloadAction = (
  refetchData: () => void,
  scopeOverride?: ResponseActionScope
): void => {
  const handler = useCallback(
    (params: unknown) => {
      if (params === true) refetchData();
    },
    [refetchData]
  );

  useRegisterResponseAction('reload', handler, scopeOverride);
};
